import config from '../../config';

export const BRAZE_BASE_URL = 'sdk.iad-07.braze.com';

export const initializeBraze = (braze) => {
    braze.initialize(config.brazeApiKey, { baseUrl: BRAZE_BASE_URL, allowUserSuppliedJavascript: true });
};

// wipeData() requires an initialized SDK, but the sign-out button can be reached from
// pages that never initialized Braze. initialize() is idempotent, so we initialize first
// to guarantee the persisted member id is actually cleared and cannot be re-asserted.
export const wipeBrazeUser = async () => {
    try {
        const braze = await import('@braze/web-sdk');
        initializeBraze(braze);
        braze.wipeData();
    } catch {
        // best-effort: never block logout if the Braze wipe fails
    }
};

// The Braze SDK caches external_id client-side and re-asserts it independently of UTR auth,
// so a merged-away or soft-deleted profile resurrects itself unless we realign it on load.
export const reconcileBrazeIdentity = async (memberId) => {
    try {
        const braze = await import('@braze/web-sdk');
        initializeBraze(braze);
        if (!memberId) {
            braze.wipeData();
            return;
        }
        const brazeUser = braze.getUser();
        const currentBrazeUserId = brazeUser ? brazeUser.getUserId() : null;
        if (String(currentBrazeUserId) !== String(memberId)) {
            braze.changeUser(memberId);
        }
    } catch {
        // best-effort: never block render if Braze reconciliation fails
    }
};
